module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b3dd5d2d612ca4a5a6f5fe5bce800e3b.png";